export default __webpack_public_path__ + "5d29254db6b248c2cc8498f77b9cd217.svg";